import { GroupCommand } from 'app/library/group/models/group.command.model';
import { ModuleGroup } from './module-group';

export class ModuleGroupCommand extends GroupCommand {
    module: {
        id: string;
    };

    constructor(moduleGroup: ModuleGroup) {
        super(moduleGroup);

        this.module = {
            id: moduleGroup.module.id,
        };
    }
}
